import React, { useState, useEffect } from 'react';
import { Card, Modal, Button, Form as BootstrapForm } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import DirectoryService from 'components/app/directory/DirectoryService';
import PaymentService from 'components/app/wod/payments/PaymentService';
import { useSearchParams } from "react-router-dom";
import schema from './jsonSchema';
const jsonSchema = schema;

const PersonalForm = ({profile, createForm=false}) => {
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [searchParams] = useSearchParams();
  const [showLinkMembershipModal, setShowLinkMembershipModal] = useState(false);
  const [membershipPlans, setMembershipPlans] = useState([]);
  const [selectedMembershipPlan, setSelectedMembershipPlan] = useState('');
  const [isLoadingMembershipPlans, setIsLoadingMembershipPlans] = useState(false);
  const [isLinkingMembershipPlan, setIsLinkingMembershipPlan] = useState(false);
  const [linkMembershipConfirmationShow, setLinkMembershipConfirmationShow] = useState(false);
  const [unlinkMembershipConfirmationShow, setUnlinkMembershipConfirmationShow] = useState(false);
  useEffect(() => {
    console.log('PersonalForm useEffect called with profile:', profile, 'createForm:', createForm);
    if (!createForm ) {
    const loggedProfile = DirectoryService.retrieveLoggedProfile();
    const identifier = undefined === profile ?  loggedProfile.identifier : profile.identifier;
    DirectoryService.retrieveProfile(identifier)
      .then(profile => {
        const formattedDate = profile.dob
          ? profile.dob.split('/').reverse().join('-')
          : '';
        const updatedData = {
          ...profile,
          dob: formattedDate
        };
        setData(updatedData);
        setShowForm(true);
      })
      .catch(() => {
        console.error('Error retrieving profile');
      });
    } else {
      setShowForm(true);
    }
  }, []);

  const handlePersonalFormSubmit = formData => {
    const avatarFile = [formData.avatar];
    const updateData = {
      ...formData,
      dob: formData.dob ? new Date(formData.dob).getTime() : null,
      groups: [],
      avatar: null,
      roles: searchParams.get("role") ? [searchParams.get("role")] : data?.roles.map(role => role.key),
    };
    console.log('Avatar:', avatarFile[0]);
    console.log('Submitting personal form data', updateData);
    const avatar = avatarFile[0] && avatarFile[0].size > 0 ? avatarFile : undefined;
    DirectoryService.saveProfile(updateData, avatar)
      .then(response => {
        console.log('Response from saveProfile:', response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
    } 


  const handleOpenLinkMembershipModal = () => {
    setSelectedMembershipPlan('');
    setShowLinkMembershipModal(true);
    setIsLoadingMembershipPlans(true);
    PaymentService.retrieveAllProductsByAccount()
      .then(products => {
        setMembershipPlans(products || []);
        setIsLoadingMembershipPlans(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoadingMembershipPlans(false);
      });
  };

  const handleLinkMembershipPlan = () => {
    if (!selectedMembershipPlan) {
      return;
    }
    setIsLinkingMembershipPlan(true);
    PaymentService.linkProductToProfile(data.identifier, selectedMembershipPlan)
      .then(() => {
        setIsLinkingMembershipPlan(false);
        setShowLinkMembershipModal(false);
        setLinkMembershipConfirmationShow(true);
      })
      .catch(error => {
        console.log(error);
        setIsLinkingMembershipPlan(false);
      });
  };

  const handleUnlinkMembershipPlan = () => {
    PaymentService.unlinkProductFromProfile(data.identifier)
      .then(() => {
        setUnlinkMembershipConfirmationShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save Details',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Details');
      }
    }
  ];
  if (DirectoryService.isLoggedByWODAdmin()) {
    buttonsConf.push({
      name: 'Link membership plan manually',
      type: 'button',
      variant: 'success',
      onClick: () => {
        handleOpenLinkMembershipModal();
      }
    });
        buttonsConf.push({
      name: 'Unlink membership plan',
      type: 'button',
      variant: 'danger',
      onClick: () => {
        handleUnlinkMembershipPlan();
      }
    });
  }
  return (
    <>
      {modalShow && (
        <FormModal
          message={'Personal details have been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl={'/app/wod/members'}
        />
      )}
      {linkMembershipConfirmationShow && (
        <FormModal
          message={'Membership plan has been linked to this profile!'}
          modalShow={linkMembershipConfirmationShow}
          setModalShow={setLinkMembershipConfirmationShow}
          redirectUrl={'/app/wod/members'}
        />
      )}
      {unlinkMembershipConfirmationShow && (
        <FormModal
          message={'Membership plan has been unlinked from this profile!'}
          modalShow={unlinkMembershipConfirmationShow}
          setModalShow={setUnlinkMembershipConfirmationShow}
          redirectUrl={'/app/wod/members'}
        />
      )}
      <Modal
        show={showLinkMembershipModal}
        onHide={() => setShowLinkMembershipModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Link membership plan manually</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoadingMembershipPlans ? (
            <p className="text-center text-muted">Loading membership plans...</p>
          ) : membershipPlans && membershipPlans.length > 0 ? (
            <BootstrapForm.Group>
              <BootstrapForm.Label>Select a membership plan</BootstrapForm.Label>
              <BootstrapForm.Select
                value={selectedMembershipPlan}
                onChange={e => setSelectedMembershipPlan(e.target.value)}
              >
                <option value="">-- Select a membership plan --</option>
                {membershipPlans.map(plan => (
                  <option key={plan.identifier} value={plan.identifier}>
                    {plan.description} {plan.price !== undefined ? `- £${plan.price}` : ''}
                  </option>
                ))}
              </BootstrapForm.Select>
            </BootstrapForm.Group>
          ) : (
            <p className="text-center text-muted">No membership plans available</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowLinkMembershipModal(false)}
            disabled={isLinkingMembershipPlan}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleLinkMembershipPlan}
            disabled={!selectedMembershipPlan || isLinkingMembershipPlan}
          >
            {isLinkingMembershipPlan ? 'Linking...' : 'Link membership plan'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Card>
        <Card.Body>
          {showForm && (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handlePersonalFormSubmit}
            />
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    jsonSchema,
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default PersonalForm;
